<script setup>
import { ref, onMounted } from "vue";
import { useModals } from "@/utils/useModals";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useQuestionnairesStore } from "@/stores/storeQuestionnaires";
import BasePhoneInput from "@/components/ui/BasePhoneInput.vue";
import BaseCheckbox from "@/components/ui/BaseCheckbox.vue";
import BaseNumberInput from "@/components/ui/BaseNumberInput.vue";

const storeField = useFieldsStore();
const storeQuestionnaires = useQuestionnairesStore();
const { openModal } = useModals();

const emit = defineEmits(['questionnaireFormShow'])

const checkingAvitoUser = async () => {
    await storeQuestionnaires.checkingAvitoUser();
    if(!!storeQuestionnaires.responseError) return
    emit('questionnaireFormShow')
}

</script>
<template>
    <div class="welcome-screen">
        <div class="container">
            <div class="welcome-screen__form form">
                <div class="welcome-screen__header">
                    <h1 class="welcome-screen__title title"><slot></slot></h1>
                    <BasePhoneInput :required="true" placeholder="+7 (900) 000-00-00" state-key="phone">Телефон</BasePhoneInput>   
                </div>
                <button 
                    class="btn-text welcome-screen__btn-text" 
                    type="button" 
                    @click="openModal('foundNumberPhone')"
                >
                    Как узнать номер телефона?
                </button>
                <div class="welcome-screen__footer">
                    <BaseCheckbox 
                        :required="true" 
                        state-key="agreement"
                        class="welcome-screen__checkbox"
                    > 
                        Даю согласие на <a href="./policy.pdf" target="_blank" rel="noopener noreferrer">обработку персональных данных</a> 
                    </BaseCheckbox>
                    <p class="form__text-error" v-if="storeQuestionnaires.responseError">{{ storeQuestionnaires.responseError }}</p>
                    <div class="form__btns">
                        <button :disabled="storeField.isBtnDisabled(['phone', 'agreement'])" :class="['send-button form__btn btn', { 'not-hover': storeQuestionnaires.loaderBtn }]" @click="checkingAvitoUser">
							<span v-if="!storeQuestionnaires.loaderBtn">Открыть форму</span>
							<img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader.svg" alt="изображение"/>
						</button>
                        <button class="btn --transparent" @click="openModal('feedback')">Связаться с поддержкой</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.welcome-screen {
	display: grid;
	place-content: center;
	min-height: 100%;
	flex: 1 1 auto;
}
.welcome-screen__form {
    display: grid;
    gap: 30px;
}
.welcome-screen__header {
    display: grid;
    gap: 24px;
}
.welcome-screen__title {
}
.welcome-screen__checkbox {
    padding: 0;
}
.welcome-screen__footer {
    display: grid;
    gap: 20px;
}
</style>